
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/industries/healthcare",
      function () {
        return require("private-next-pages/solutions/industries/healthcare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/industries/healthcare"])
      });
    }
  